// Fetch list

export const FETCH = 'carrierContacts.FETCH'
export const FETCH_STARTED = 'carrierContacts.FETCH_STARTED'
export const FETCH_FULFILLED = 'carrierContacts.FETCH_FULFILLED'
export const FETCH_REJECTED = 'carrierContacts.FETCH_REJECTED'
export const FETCH_CANCELLED = 'carrierContacts.FETCH_CANCELLED'

export const SORTING_CHANGED = 'carrierContacts.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'carrierContacts.FETCH_ONE'
export const FETCH_ONE_STARTED = 'carrierContacts.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'carrierContacts.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'carrierContacts.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'carrierContacts.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'carrierContacts.SAVE'
export const SAVE_STARTED = 'carrierContacts.SAVE_STARTED'
export const SAVE_FULFILLED = 'carrierContacts.SAVE_FULFILLED'
export const SAVE_REJECTED = 'carrierContacts.SAVE_REJECTED'
export const SAVE_CANCELLED = 'carrierContacts.SAVE_CANCELLED'
export const SAVE_DUPLICITY_FOUND = 'carrierContacts.SAVE_DUPLICITY_FOUND'

// Delete

export const DELETE = 'carrierContacts.DELETE'
export const DELETE_STARTED = 'carrierContacts.DELETE_STARTED'
export const DELETE_FULFILLED = 'carrierContacts.DELETE_FULFILLED'
export const DELETE_REJECTED = 'carrierContacts.DELETE_REJECTED'
export const DELETE_CANCELLED = 'carrierContacts.DELETE_CANCELLED'

// Export

export const EXPORT = 'carrierContacts.EXPORT'
export const EXPORT_FULFILLED = 'carrierContacts.EXPORT_FULFILLED'
